// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"b06cf2c8","703":"cc696402"}[chunkId] + ".chunk.js";
};